import type {DateValueEditorLocalizations, DateValueEditorOptions} from './types';
import type {DefaultOptions} from '../../types';


/**
 * @ngdoc constant
 * @name DATE_VALUE_EDITOR_DEFAULT_OPTIONS
 * @module portaro.value-editors.date
 *
 * @description
 * For description see {@link DateValueEditorOptions}
 *
 * ```javascript
 *  {
 *      viewFormat: 'd.L.y',
 *      onlyDate: false,
 *      maximumGranularity: 'date-only',
 *  }
 * ```
 */
export const DATE_VALUE_EDITOR_DEFAULT_OPTIONS: DefaultOptions<DateValueEditorOptions> = {
    viewFormat: 'd.L.y',
    onlyDate: false,
    maximumGranularity: 'date-only',
};


/**
 * @ngdoc constant
 * @name DATE_VALUE_EDITOR_DEFAULT_LOCALIZATIONS
 * @module portaro.value-editors.date
 *
 * @description
 * ```
 * {
 *      description: '',
 *      openCalendar: 'Open calendar popup (be advised, keyboard navigation could be complicated)'
 * }
 * ```
 */
export const DATE_VALUE_EDITOR_DEFAULT_LOCALIZATIONS: Readonly<Required<DateValueEditorLocalizations>> = Object.freeze({
    description: '',
    openCalendar: 'Open calendar popup (be advised, keyboard navigation could be complicated)'
});